// app/javascript/compcalc/components/QME.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import List from '@material-ui/core/List';
import TextField from '@material-ui/core/TextField';

import withErrorHandling from './ErrorHandling';
import ItemArrayList from './utils/ItemArrayList';


const styles = theme => ({
  root: {
    // flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: theme.spacing(1),
  },
  inputLabel: {
    fontSize: 22,
    // fontWeight: 'bold',
    // marginBottom: 1*theme.spacing(1), // TODO: margin not working.
  },
  dateField: {
    width: 150,
  },
  group: {
    display: 'flex',
    flexFlow: 'row nowrap',
  },
  listItem: {
    // height: '80% !important',
  },
  textFieldDense: {
    margin: 0,
  },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',        // Vertical align.
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  wrapContent: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  wrapContent1: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: 2,
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class QME extends React.PureComponent {

  constructor(props) {
    super(props);
    // console.log('QME.constructor()')

    this.initialState = {
      qme: 0,
      qmes: [],
      qmesSearch: [],
      qmeSearchIndex: 0,
      qmeSearchString: '',
      qmeCode: '?',

      body: 0,
      bodies: [],
      bodiesSearch: [],
      bodySearchIndex: 0,
      bodySearchString: '',
      bodyPartCode: '?',
    };
    this.state = { ...this.initialState };
  }

  componentDidMount = () => {
    // console.log('QME.componentDidMount()')
    this.fetchQmes();
    this.fetchBodies();
  }

  // --------------------- Fetching ---------------------
  fetchQmes = () => {
    let url = 'api/v1/qme_codes.json';
    this.props.fetch(url, results => {
      this.updateQmes(results);
    }).catch(e => this.props.showError(e, 'Error obtaining QME codes from server'));
  }

  fetchBodies = () => {
    let url = 'api/v1/body_part_codes.json';
    this.props.fetch(url, results => {
      this.updateBodies(results);
    }).catch(e => this.props.showError(e, 'Error obtaining body part codes from server'));
  }

  // --------------------- Updating ---------------------
  updateQmes = (result) => {
    // console.log(result);

    var qmes = result['qme-codes'];
    this.setState({
      qmes: qmes,
      qmesSearch: qmes,
      qme: 0,
      qmeSearchIndex: 0,
      qmeSearchString: '',
      qmeCode: qmes[0][1],
    });
  }

  updateBodies = (result) => {
    var bodies = result['body-part-codes'];
    this.setState({
      bodies: bodies,
      bodiesSearch: bodies,
      body: 0,
      bodySearchIndex: 0,
      bodySearchString: '',
      bodyPartCode: bodies[0][1],
    });
  }

  // --------------------- Selection changed events ---------------------
  onQmeIndexChanged = (index) => {
    if (this.state.qmeSearchIndex == index) { return; }
    var current = this.state.qmesSearch[index];
    var realIndex = this.state.qmes.indexOf(current);
    this.setState({
      qme: realIndex,
      qmeSearchIndex: index,
      qmeCode: current[1],
    });
  }

  onBodyIndexChanged = (index) => {
    if (this.state.bodySearchIndex == index) { return; }
    var current = this.state.bodiesSearch[index];
    var realIndex = this.state.bodies.indexOf(current);
    this.setState({
      body: realIndex,
      bodySearchIndex: index,
      bodyPartCode: current[1],
    });
  }

  // --------------------- Search changed ---------------------
  onQmeSearchChanged = (e) => {
    let search = e.target.value;
    if (this.state.qmes.length === 0) return;
    var searchLower = search.toLowerCase();
    var current = this.state.qmes[this.state.qme];
    var filtered = this.state.qmes.filter( (item) =>
      item[0].toLowerCase().indexOf(searchLower) >= 0 || item[1].toLowerCase().indexOf(searchLower) >= 0
    );
    var indexFiltered = filtered.indexOf(current);

    this.setState({
      qmesSearch: filtered,
      qmeSearchIndex: indexFiltered,
      qmeSearchString: search,
    });
  }

  onBodySearchChanged = (e) => {
    let search = e.target.value;
    if (this.state.bodies.length === 0) return;
    var searchLower = search.toLowerCase();
    var current = this.state.bodies[this.state.body];
    var filtered = this.state.bodies.filter( (item) =>
      item[0].toLowerCase().indexOf(searchLower) >= 0 || item[1].toLowerCase().indexOf(searchLower) >= 0
    );
    var indexFiltered = filtered.indexOf(current);

    this.setState({
      bodiesSearch: filtered,
      bodySearchIndex: indexFiltered,
      bodySearchString: search,
    });
  }

  // --------------------- Rendering ---------------------
  render() {
    const { classes } = this.props;

    return (
      <div style={{height: '100%'}}>
      <Grid container spacing={1} className={classes.root}>

        <Grid item xs={2} />
        {/* QME Codes */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent1}>
            <FormControl className={classes.marginBottom}>
              <TextField
                value={ this.state.qmeSearchString }
                onChange={ this.onQmeSearchChanged }
                label="Search QME Specialty"
                input={<Input id="searchQme" name="searchQme" />}
              >
              </TextField>
            </FormControl>
            <List subheader="QME Specialty">
              <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
                <ItemArrayList name='QME Specialty'
                               items = { this.state.qmesSearch }
                               textIndex = { 0 }
                               selectedIndex = { this.state.qmeSearchIndex }
                               onIndexChanged = { this.onQmeIndexChanged } />
              </div>
            </List>
          </Paper>
        </Grid>

        {/* Body Part Codes */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent1}>
            <FormControl className={classes.marginBottom}>
              <TextField
                value={ this.state.bodySearchString }
                onChange={ this.onBodySearchChanged }
                label="Search Body Part"
                input={<Input id="searchBody" name="searchBody" />}
              >
              </TextField>
            </FormControl>
            <List subheader="Body Part">
              <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
                <ItemArrayList name='Body Part'
                               items = { this.state.bodiesSearch }
                               textIndex = { 0 }
                               selectedIndex = { this.state.bodySearchIndex }
                               onIndexChanged = { this.onBodyIndexChanged } />
              </div>
            </List>
          </Paper>
        </Grid>
        <Grid item xs={2} />

        <Grid item xs={2} />
        <Grid item xs={4} className={classes.alignCenter}>
          {/* QME Code */}
          <Paper className={classes.wrapContent}>
            <TextField
              id="qmeCode"
              label="Body Part Code"
              variant="outlined"
              value={ this.state.qmeCode }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          {/* Body Part Code */}
          <Paper className={classes.wrapContent}>
            <TextField
              error={ this.state.warning != null }
              id="amount"
              label="QME Code"
              variant="outlined"
              value={ this.state.bodyPartCode }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>
        <Grid item xs={2} />

      </Grid>
      </div>
    );
  }

};

export default withStyles(styles)(withErrorHandling(QME));
